"use strict";

const numeral = require("numeral");
const { eNegotiationErrorId, eNegotiationJourney } = require("./enums/negotiation");

function getNegotiationErrorMessage(errorData, negotiationJourney) {
  const { errorId, message, creditRemaining } = errorData;
  if (errorId === eNegotiationErrorId.RelationshipCreditInsufficient) {
    return `${message} Remaining credit is £${numeral(creditRemaining).format("0,0.00")}`;
  }
  if (negotiationJourney === eNegotiationJourney.Counter) {
    return "Sorry, we are unable to place your counter offer at the moment.";
  }
  if (negotiationJourney === eNegotiationJourney.Accept) {
    return "Sorry, negotiation has either expired, been accepted or withdrawn. Please refresh your page.";
  }
}

export { getNegotiationErrorMessage };
